// extracted by mini-css-extract-plugin
export default {"raisedBox":"styles_raisedBox__CxQLz","flatBox":"styles_flatBox__EKh1a"};